<video #backgroundVideo playsinline autoplay muted loop class="background-video">
    <source src="{{src}}">
</video>
